import { render, staticRenderFns } from "./seoOptimize.vue?vue&type=template&id=0c6da6aa&scoped=true&"
import script from "./seoOptimize.vue?vue&type=script&lang=js&"
export * from "./seoOptimize.vue?vue&type=script&lang=js&"
import style0 from "./seoOptimize.vue?vue&type=style&index=0&id=0c6da6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6da6aa",
  null
  
)

export default component.exports